import { useParams } from 'react-router-dom';
import { useLabelGroupsQuery } from '../../gpanel-contacts-queries';

export function useLabelFromGroups() {
  const { labelId } = useParams<{ labelId: string }>();
  const id = parseInt(labelId ?? '');

  const { data } = useLabelGroupsQuery();
  const groups = data?.labelGroups ?? [];
  const allLabels = groups.flatMap((group) => group.labels);
  const label = allLabels.find((label) => label.id === id) ?? null;

  return label;
}
